
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(5(2181|2813|3390)|3(0298|3358|6031|7674)|9((24|97)58|2371|5573|874)|(1429|6594|7595)1|(264|438)12|(2906|417|8678)3|13244|69885|73228|89460)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
